export enum EnumTipoValidacion {
  Si = 1,
  No,
  Rechazado
}
